
// ***************************************************************************************
// addChar() appelée par l'application lors de l'appui sur une touche du clavier
// correspondant à un nouveau caractère à insérer dans le script
// ***************************************************************************************
export function addChar(char) {
  if (this.readonly || !this.active) {
    return;
  }

  this.addCommonChar(char);
}

// ***************************************************************************************
// addHebrewOrArabicChar()
// on ajoute les caractères en hébreu et en arabe de droite à gauche
// ***************************************************************************************
export function addHebrewOrArabicChar(char) {
  if (this.readonly || !this.active || this.underSelection) {
    return;
  }

  this.addCommonHebrewOrArabicChar(char);
}